import BaseSettingHandler from './BaseSettingHandler';
import HELPER from '@/app/utils/HELPER';

/**
 * CustomAlignSettingHandler
 */
export class ShCustomAlign extends BaseSettingHandler {
  /**
   * read
   * @param options options
   */
  read(options: { $atom: JQuery; screenType: string; $activePanel: JQuery }) {
    const $target = options.$atom.find(this.setting.targetSelector as string);
    const format = this.getFormat();
    let align = HELPER.getResponsiveAlign($target, options.screenType, format);
    if (this.setting.require) {
      align = $target.css(this.setting.property);
    }
    options.$activePanel.find(`[name="${this.setting.name}"]`).attr('value', align).val(align).trigger('value-change');
    return { value: align };
  }

  /**
   * write
   * @param value value
   * @param options options
   * @returns returns
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
      screenType: string;
    },
  ): { refreshType: string; style?: string | undefined } {
    const $target = options.$atom.find(this.setting.targetSelector as string);
    const format = this.getFormat();
    HELPER.setResponsiveAlign(value, $target, options.screenType, format);
    return {
      refreshType: 'css',
    };
  }

  /**
   * getFormat
   * @returns format
   */
  getFormat(): string {
    if (this.setting.attrStoredSelector == '.module') {
      return 'gf_module';
    } else if (this.setting.attrStoredSelector == '.elm') {
      return 'gf-elm';
    } else if (this.setting.attrStoredSelector) {
      return this.setting.attrStoredSelector;
    }
    return 'gf-elm';
  }
}
